import React, { useMemo } from 'react';
import HeaderContainer from '../../containers/common/HeaderContainer';
import Navigation from '../../components/common/Navigation';
import { SideSpacer } from '../../components/common/Spacer';
import MemberListContainer from '../../containers/member/list/MemberListContainer';
import {
  CommonContainer,
  HistoryActiveStyle,
  HistoryURL,
  HistoryBlock,
} from '../../components/common/Container';
import SearchContainer from '../../containers/common/SearchContainer';
import { useSelector } from 'react-redux';
import { inputNumberAutoComma } from '../../lib/commonFunc/commonFunc';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

const MemberListPage = () => {
  const location = useLocation();
  const { memberCount } = useSelector(
    ({ search }) => ({
      memberCount: search.memberCount,
    }),
  );

  const { pageParam, searchParam } = useMemo(() => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    const pageValue = query.page ? String(query.page) : '1';
    const searchValue =
      typeof query.searchText === 'string' ? query.searchText : '';
    return {
      pageParam: pageValue,
      searchParam: searchValue,
    };
  }, [location.search]);
    
  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <CommonContainer>
          <HistoryBlock>
            <HistoryURL to="/member/" activeStyle={HistoryActiveStyle}>
              <div>회원목록{memberCount ? <span style={{fontSize: '.9rem'}}> ({inputNumberAutoComma(memberCount)}명)</span> : <span style={{fontSize: '.9rem'}}> (0명)</span>}</div>
            </HistoryURL>
          </HistoryBlock>
          <MemberListContainer
            initialPage={pageParam}
            initialSearchText={searchParam}
          />
        </CommonContainer>
      </SideSpacer>
    </>
  );
};

export default MemberListPage;
